/**
 * Chemins de la feature `purchases` — centralisés ici pour éviter les paths
 * hardcodés dans les vues, les routes et la navigation (cf. front/CLAUDE.md §3).
 */
export const PURCHASES_PATHS = {
  /** Catalogue des offres. */
  root: '/purchases',
  /** Achat du test complet (toutes les évaluations). */
  complete: '/purchases/complete',
  /** Sélection d'un pack d'évaluations. */
  packEval: '/purchases/pack-eval',
  /** Historique des achats de l'utilisateur. */
  history: '/my-purchases',
  /**
   * Retour Stripe après paiement réussi. Doit correspondre à `SUCCESS_URL`
   * configuré côté ms-payment (`http://localhost:5173/payment/success` en local).
   */
  paymentSuccess: '/payment/success',
  /** Retour Stripe après annulation. Doit correspondre à `CANCEL_URL` ms-payment. */
  paymentCancel: '/payment/cancel',
} as const;
